export default {
    sharp: 0,
    xxs: 4,
    xs: 8,
    s: 12,
    sm: 16,
    m: 20,
    ml: 24,
    lg: 28,
    xl: 32,
    round: 9999,
};
